/**
 * defaultScheduleNotice.js — the one sentence the deploy modal says when a
 * template DECLARES a default schedule.
 *
 * A template may declare `marketplace.defaultSchedule`; marketplace-sync-core
 * copies it onto the row (with a `summary` it derives once — "every 15
 * minutes") and the deploy installs that cron on an agent that has no schedule
 * yet (backend services/deploy-schedule.js, seed-only). The modal must SAY so
 * before the click — a fleet that starts running on its own the moment it is
 * deployed is something the operator consents to — and must say it as a FACT,
 * not offer a control: the schedule is changed or paused on the agent page,
 * which has the real editor; a second one here would be the fake input the
 * north star forbids. Pure function of the row; null for every card that
 * declares none, so those render byte-identically. Mirrored word-for-word in
 * the self-host dashboard's defaultScheduleNoticeHtml (the two share no code).
 */
export function defaultScheduleNotice(entry) {
  const ds = entry && entry.defaultSchedule;
  if (!ds || typeof ds !== 'object' || !ds.cron) return null;
  const when = ds.summary || `on the schedule "${ds.cron}"`;
  return `Runs ${when} after deploy — change or pause it on the agent page.`;
}
